import { pb } from "../pocketbase/pocketbase";
import { Training } from "../../core/training/entities/Training";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapRecordToTraining(record: any): Training {
  return {
    id: record.id,
    name: record.name,
    description: record.description,
    created: record.created ?? record.created_at ?? "",
  };
}

export const trainingRepository = {
  async getAll() {
    const records = await pb.collection("trainings").getFullList({
      requestKey: null,
    });
    return records.map(mapRecordToTraining);
  },
};
